import React, { createContext, useContext, useState } from 'react';

interface SettingsPanelContextType {
  closeSettingsPanel: boolean;
  setCloseSettingsPanel: (close: boolean) => void;
}

const SettingsPanelContext = createContext<SettingsPanelContextType | null>(
  null,
);

export const SettingsPanelProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [closeSettingsPanel, setCloseSettingsPanel] = useState(false);

  return (
    <SettingsPanelContext.Provider
      value={{ closeSettingsPanel, setCloseSettingsPanel }}
    >
      {children}
    </SettingsPanelContext.Provider>
  );
};

export const useSettingsPanel = () => {
  const context = useContext(SettingsPanelContext);
  if (!context) {
    throw new Error(
      'useSettingsPanel must be used within a SettingsPanelProvider',
    );
  }
  return context;
};
